/* Accordion for the PDP's product-info sections.
 * The collapse itself is pure CSS — `grid-template-rows: 1fr / 0fr` — so this
 * only flips aria-expanded and a class. Nothing is measured, and a panel whose
 * transition never runs is still either open at its correct height or closed. */
(function () {
  'use strict';
  var root = document.querySelector('[data-sys-info]');
  if (!root) return;
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('.sys-acc__btn');
    if (!btn || !root.contains(btn)) return;
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    panel.classList.toggle('is-open', !open);
  });
})();
